import { createEffect, For, createMemo, createSignal, onMount, Signal, Accessor, Setter, Show } from 'solid-js';
import { delay } from 'common'
import AILoader from '../st-ai-loader/st-ai-loader';
import './st-generated-text-preview.less';
import STButton, { ButtonType } from '../st-button/st-button';
import STCheckbox from '../st-checkbox/st-checkbox';

const [documentSelectedText, setDocumentSelectedText] = createSignal('')
document.addEventListener("selectionchange", event => {
    let selection = document.getSelection()?.toString();
    setDocumentSelectedText(selection || '');
})

class GeneratedTextPreviewOptions {
    generatedText: string[] = [];
    generatedItems: SelectedText[] = [];
    label?: string = '';
    loading: boolean = false;
    onReplace: () => void = () => { };
}

export class SelectedText {
    text: string = '';
    selected: Accessor<boolean>;
    setSelected: Setter<boolean>;

    constructor(text: string) {
        this.text = text;
        [this.selected, this.setSelected] = createSignal(false);
    }
}

export const defaultProps = new GeneratedTextPreviewOptions();

export function GeneratedTextPreview(props: GeneratedTextPreviewOptions) {
    const generatedText = createMemo(() => props.generatedText || []);

    const loading = createMemo(() => props.loading);
    const [showLoader, setShowLoader] = createSignal(true);
    const [showContent, setShowContent] = createSignal(false);
    const [contentOpacity, setContentOpacity] = createSignal(0);
    const [loaderOpacity, setLoaderOpacity] = createSignal(1);

    let transitioning = false;
    createEffect(() => {
        const hasText = !!generatedText() && generatedText().length > 0;

        (async () => {
            if (!transitioning) {
                transitioning = true;
                // fade in content
                if (hasText) {
                    if (loaderOpacity()) {
                        setLoaderOpacity(0);
                        await delay(1000);
                        setShowLoader(false);
                    }
                    setShowContent(true);
                    await delay(1000);
                    setContentOpacity(1);
                }
                // fade out content
                else {
                    if (contentOpacity()) {
                        setContentOpacity(0);
                        setShowContent(false);
                    }
                    setShowLoader(true);
                    await delay(100);
                    setLoaderOpacity(1);
                }
                transitioning = false;
            }
        })();
    });

    return <div class="auto flexbox vertical st-generated-text-preview">
        <div class="flexbox horizontal middle" style="margin: 0 10px">
            <div class="label">{props.label}</div>
        </div>
        <div class="auto flexbox vertical text-preview" classList={{ loading: loading() }}>
            <div class="auto flexbox vertical" style="align-items: left; overflow: auto">
                <div class="ai-loader" style={{ display: (showLoader() ? '' : 'none'), opacity: loaderOpacity() }} >
                    <AILoader processing={loading()} size="300px"></AILoader>
                </div>
                <Show when={showContent()}>
                    <For each={props.generatedItems}>{it =>
                        <Item generatedItem={it}></Item>
                    }</For>
                </Show>
            </div>
        </div>
        <div class="flexbox horizontal middle" style="margin: 0 10px; position: absolute; top: 100%; left: 0; right: 0;">
            <div class="auto"></div>
            <div style="z-index:1">
                <STButton type="success" enabled={!!generatedText()} onClick={props.onReplace}>Add</STButton>
            </div>
            <div class="auto"></div>
        </div>
    </div>
}

function Item(props: { generatedItem: SelectedText }) {
    return <div class="flexbox horizontal padded"><STCheckbox label='' value={ [props.generatedItem.selected, props.generatedItem.setSelected] } />{props.generatedItem.text}</div>
}
